// extracted by mini-css-extract-plugin
module.exports = {"ScrollPane":"ImageSlider_ScrollPane__3JDfk","Container":"ImageSlider_Container__2Zb6g","SliderItem":"ImageSlider_SliderItem__wVoyn"};